import React from 'react';

interface Props {
  icon: React.FC<{ className?: string }>;
  title: string;
  description: string;
}

/**
 * A pure extraction of the "no data yet" pattern every module in this
 * codebase already hand-rolls identically (e.g.
 * ProjectManagement/Meetings/MeetingsRegistryTab.tsx) — not a new design.
 * Pulled into one component for BD-04 specifically because that ticket
 * creates 8 instances of it inside ONE new file that future BD tickets will
 * keep editing one tab at a time; that's a different situation from the
 * rest of the codebase's "hand-roll per page" convention, where each
 * instance lives in its own independently-owned file.
 */
const EmptyState: React.FC<Props> = ({ icon: Icon, title, description }) => (
  <div className="text-center py-16 text-gray-400">
    <Icon className="w-12 h-12 mx-auto mb-3 opacity-40" />
    <p className="text-lg font-medium">{title}</p>
    <p className="text-sm mt-1">{description}</p>
  </div>
);

export default EmptyState;
